













































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { mdiHome, mdiDotsHorizontal } from "@mdi/js";
import DeleteDialog from "@/components/modals/DeleteDialog.vue";


@Component({
  components: {
    DeleteDialog
  }
})
export default class PracticeInfo extends Vue {
  @namespace('practices').Action('updatePractice') actionUpdatePractice!: any;
  @Prop({ default: null }) practiceInfo!: any;
  private newPracticeInfo: any;
  private edit: boolean = false;
  deleteDialog: boolean = false;

  created() {
    this.newPracticeInfo = { ...this.practiceInfo };
    this.$root.$on("closeDeleteDialog", () => {
      this.deleteDialog = false;
    });
  }

  async toggleEdit() {
    this.edit = !this.edit;

    if (this.edit) {
      let practice = { id: this.practiceInfo.id };
      // TODO: get practiceInfo fields that changed
      // find only updated properties on newPracticeInfo

      let results = await this.actionUpdatePractice(practice);
    }
  }

  get editBtnName() {
    return !this.edit ? "Edit" : "Save";
  }
}
